import { render, staticRenderFns } from "./homepage.vue?vue&type=template&id=232849de&scoped=true&"
import script from "./homepage.vue?vue&type=script&lang=js&"
export * from "./homepage.vue?vue&type=script&lang=js&"
import style0 from "./homepage.vue?vue&type=style&index=0&id=232849de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232849de",
  null
  
)

export default component.exports